const DEFAULT_WARNING_MINUTES = 2;

export function sessionDeadline(expiresIn: string, now = Date.now()): number {
  const match = /^(\d+)\s*(s|m|h|d)$/i.exec(expiresIn.trim());
  if (!match) return now;
  const unitMilliseconds = { s: 1_000, m: 60_000, h: 3_600_000, d: 86_400_000 };
  return (
    now +
    Number(match[1]) *
      unitMilliseconds[match[2].toLowerCase() as keyof typeof unitMilliseconds]
  );
}

export function sessionWarningMilliseconds(value?: string): number {
  const minutes = Number(value);
  return (
    (Number.isFinite(minutes) && minutes > 0
      ? minutes
      : DEFAULT_WARNING_MINUTES) *
    60 *
    1000
  );
}
